import styled from 'styled-components';

// Components
import { Typography } from '../../../display/Typography';
import { MainButton } from '../../../inputs/buttons/MainButton';
import InputText from '../../../inputs/InputText';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 70vh;
`;

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1rem 0;
  max-height: 60vh;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledInputText = styled(InputText)`
  > p {
    margin-top: 0.5rem;
  }
`;

export const SectionTitle = styled(Typography)`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.black};
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const SelectionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 15rem;
  overflow-y: auto;
  border: 1px solid ${({ theme }) => theme.colors.greySoftLight};
  border-radius: 0.5rem;
  padding: 0.5rem;
`;

export const SelectionItem = styled.label`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  border-radius: 0.25rem;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.greyLight};
  }
`;

export const SelectionCheckbox = styled.input.attrs({ type: 'checkbox' })`
  width: 1.6rem;
  height: 1.6rem;
  cursor: pointer;
`;

export const SelectionLabel = styled(Typography)`
  font-size: 1.3rem;
`;

export const EmptyMessage = styled(Typography)`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.greyDark};
  text-align: center;
  padding: 1rem;
`;

export const StickyFooter = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  padding: 1.5rem 0 0.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  margin-top: auto;

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column-reverse;
    gap: 0.5rem;
  }
`;

export const CancelButton = styled(MainButton)`
  min-width: 10rem;

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;

export const SubmitButton = styled(MainButton)`
  min-width: 10rem;

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;

export const DeleteButton = styled(MainButton)`
  min-width: 10rem;
  margin-right: auto;
  background-color: ${({ theme }) => theme.colors.red};
  color: ${({ theme }) => theme.colors.white};

  &:hover:not(:disabled):not(:focus-visible) {
    background-color: ${({ theme }) => theme.colors.darkBrickRed} !important;
    opacity: 1;
  }

  &:active:not(:disabled):not(:focus-visible) {
    background-color: ${({ theme }) => theme.colors.red} !important;
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
    margin-right: 0;
  }
`;
